module.exports = __webpack_public_path__ + "img/galeria-07.921f62fc.jpg";